var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgWarehousePlanogram = function SvgWarehousePlanogram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.889 3.71v13.18L9.5 16.24l-7.389.648V3.71l2.52.22-.113 1.184-1.175-.104-.001 5.288h3.695v1.189l-3.695-.001v1.188h5.542v2.427l.616-.054.615.054v-2.427h5.542v-1.188h-3.694V10.3h3.694V5.01l-1.175.104-.112-1.183 2.519-.221zM3.343 15.589l4.309-.378v-1.347h-4.31v1.725zm12.314-1.725h-4.31v1.347l4.31.378v-1.725zM9.5 3.167c1.632 0 3.07 1.032 3.539 2.54.468 1.508-.144 3.133-1.507 3.999L9.5 11.753 7.468 9.706C6.105 8.84 5.493 7.215 5.961 5.707c.469-1.508 1.907-2.54 3.539-2.54zm0 1.194c-1.098-.003-2.064.697-2.367 1.715-.304 1.017.13 2.105 1.061 2.665l.116.093 1.19 1.2 1.306-1.293c.932-.56 1.365-1.648 1.061-2.665-.303-1.018-1.27-1.718-2.367-1.715zm.616 1.782V7.33H8.884V6.143h1.232z",
    fill: "#000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h19v19H0z"
  }))));
};

export default SvgWarehousePlanogram;